{
	"trailingStop": {
		"price": "Трейлинг,$",
		"percent": "Трейлинг,%",
		"trailPrice": "Трейл цена",
		"trailPercent": "Трейл процент"
	}
}
